<template>
	<footer class="pt-3 pt-md-5 d-none d-md-block">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center mb-3 mb-md-5">
					<img class="img-fluid logo-milagros" src="assets/logo-milagros.png" alt="">
				</div>
				<div class="col-12 d-md-flex pr-0">
					<div class="col-12 col-md-12 d-md-flex mt-3 mt-md-0 pl-0">
						<div class="col-12 col-md-6 d-flex p-0">
							<div class="col-6">
								<div class="col-12 p-0">
									<h6>Layanan Costumer</h6>
									<ul class="item-footer pl-0 pt-2">
										<li>
											<p class="mb-2 color-gray">0853 9996 1000 (SMS)</p>
										</li>
										<li>
											<p class="mb-2 color-gray">0853 9996 2000 (Telepon/WA)</p>
										</li>
									</ul>
									<h6>Layanan Umum</h6>
									<ul class="item-footer pl-0 pt-2">
										<li>
											<p class="color-gray mb-2">0819 3111 3339 (SMS)</p>
										</li>
										<li>
											<p class="color-gray mb-2">085 777 008 009  (Telepon)</p>
										</li>
									</ul>
								</div>
							</div>
							<div class="col-6">
								<div class="col-12 p-0">
									<h6>Layanan Mobile Counter</h6>
									<ul class="item-footer pl-0 pt-2">
										<li>
											<p class="mb-2 color-gray">0821 870 60000 (SMS Konfirmasi)</p>
										</li>
										<li>
											<p class="mb-2 color-gray">0821 8872 2000 (Telepon/WA)</p>
										</li>
									</ul>
									<h6>Supervisi Pelayanan</h6>
									<ul class="item-footer pl-0 pt-2">
										<li>
											<p class="color-gray mb-2">0813 555 22 000</p>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-3">
							<h6>Temukan Kami</h6>
							<ul class="item-footer pl-0 pt-2">
								<div class="col-12 p-0 d-flex d-md-block">
									<div class="col-6 p-0 col-md-12">
										<li>
											<p class="mb-2 color-gray">Milagros</p>
										</li>
										<li>
											<p class="mb-2 color-gray">Paskal Hyper Square</p>
										</li>
										<li>
											<p class="mb-2 color-gray">Blok F8 sd F10</p>
										</li>
									</div>
									<div class="col-6 p-0 col-md-12">
										<li>
											<p class="mb-2 color-gray">Pasirkaliki Bandung Jawa Barat</p>
										</li>
										<li>
											<p class="mb-2 color-gray">(022) 87803653</p>
										</li>
										<li>
											<p class="mb-2 color-gray">(022) 87803655</p>
										</li>
									</div>
								</div>
							</ul>
						</div>
						<div class="col-12 col-md-3 d-flex d-md-block">
							<div class="col p-0">
								<a href="https://www.facebook.com/milagros.indonesia" class="btn btn-primary rounded-circle button-footer mt-1 d-flex box-purple">
									<font-awesome-icon :icon="['fab', 'facebook']" class="ml-n1 font-size-21 font-size-sm-12"/>
									<span class="font-size-13 ml-3 color-white font-size-sm-8">Facebook</span>
								</a>
							</div>
							<div class="col p-0">
								<a href="https://www.instagram.com/official_milagros" class="btn btn-primary rounded-circle button-footer mt-1 d-flex box-purple">
									<font-awesome-icon :icon="['fab', 'instagram']" class="ml-n1 font-size-21 font-size-sm-12"/>
									<span class="font-size-13 ml-3 color-white font-size-sm-8">Instagram</span>
								</a>
							</div>
							<div class="col p-0">
								<a href="https://www.youtube.com/channel/UCVcqoeGst-v5AheVZ7yZfAg" class="btn btn-primary rounded-circle button-footer mt-1 pl-2 d-flex box-purple">
									<font-awesome-icon :icon="['fab', 'youtube']" class="ml-n1 font-size-21 font-size-sm-12"/>
									<span class="font-size-13 ml-3 color-white font-size-sm-8">Youtube</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 text-center mt-3 pt-3 pb-3 copyright">
			<span class="font-size-13 font-size-sm-9 color-white">Copyright &copy; 2019 Milagros - Miracle Inside. All Right Reserved</span>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'MlFooter',
		props: {
			msg: String
		}
	}
</script>

<style>
svg.icon-footer{
	font-size: 32px;
}
@media (max-width: 425px){
	svg.icon-footer{
		font-size: 18px;
	}
}
</style>
